import axios from 'axios';
import { API_URL } from '../config';

const BASE_URL = API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});


// Helper function to construct image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  return `${BASE_URL}${imagePath}`;
};

//Add token to requests if it exists
/*api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});*/

// Articles API
export const getArticles = async (page=1) => {
  try {
    const response = await api.get(`/news?page=${page}&view=feed`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch articles');
  }
};

export const getArticle = async (id,source=false) => {
  try {
    const response = await api.get(`/news/${id}?source=${source}&media=url`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch article');
  }
};

export const deleteArticle = async (id) => {
  try {
    const response = await api.delete(`/news/${id}`);
    return response.data;
  } catch (error) {
    let status = error.response.status;
    throw new Error(status)
  }
};

export const getSourceType = async () => {
  try {
    const response = await api.get(`/source`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch sources');
  }
};

export const getArticleByCategory = async (cat,page=1) => {
  try {
    const response = await api.get(`/category/${encodeURIComponent(cat)}?page=${page}&view=feed`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch article');
  }
};

// Auth API
export const login = async (credentials) => {
  try {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};

export const addArticle = async (data) => {
  try {
    const response = await api.post('/news?media=url', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add article');
  }
};

// Upload API
export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    
    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to upload image');
  }
}

  export const loginOAuth = async (credentials) => {
    try {
      const response = await api.post('/auth/googleSignIn', credentials);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  };

  export const verifyToken = async () => {
    try {
      const response = await api.post('/auth/verifyAccessToken');
      //console.log(response)
      return response.status;
    } 
    catch (error) {
      throw new Error(error?.status || 'Login failed');
    }
  };




// Payment API
export const createPayment = async (data) => {
  try {
    const response = await api.post('/payments/create', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Could not start payment.');
  }
};

export const getPaymentStatus = async (txnid) => {
  try {
    const response = await api.get(`/payments/${txnid}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Could not fetch payment status.');
  }
};

export const verifyPayment = async (txnid) => {
  try {
    const response = await api.post(`/payments/${txnid}/verify`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Could not verify payment.');
  }
};

// Gateway-independent donation API. Keep the request ID stable for retries.
export const createDonation = async (data) => {
  const response = await api.post('/donations', data);
  return response.data;
};

export const startDonationCheckout = async (donationId) => {
  const response = await api.post(`/donations/${encodeURIComponent(donationId)}/checkout`);
  return response.data;
};

export const getDonationStatus = async (donationId) => {
  const response = await api.get(`/donations/${encodeURIComponent(donationId)}/status`);
  return response.data;
};

export default api;

export const getSession = async () => (await api.get('/auth/session')).data;
export const logoutSession = async () => api.post('/auth/logout');
